/* ring-sizer.js (Shopify-safe, jQuery-free, DPR-correct canvas)
   - robust tap/click/pointer handling
   - press & hold for +/- buttons
   - ruler canvas renders correctly in Shopify themes (devicePixelRatio scaling + fixed CSS height)
*/

(function () {
  "use strict";

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  // Best effort: one "tap" handler that works on desktop + mobile
  function bindTap(el, handler) {
    if (!el) return;
    const opts = { passive: false };

    const run = (e) => {
      if (e) e.preventDefault();
      handler(e);
    };

    // pointerdown is most reliable
    el.addEventListener("pointerdown", run, opts);
    // fallbacks
    el.addEventListener("touchstart", run, opts);
    el.addEventListener("click", run, opts);

    // keyboard accessibility
    el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handler(e);
      }
    });
  }

  function pressAndHold(btn, onStep) {
    if (!btn) return;
    let timer = null;

    const start = (e) => {
      e.preventDefault();
      onStep();
      stop();
      timer = window.setInterval(onStep, 50);
    };

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    btn.addEventListener("pointerdown", start, { passive: false });
    btn.addEventListener("touchstart", start, { passive: false });
    btn.addEventListener("mousedown", start, { passive: false });

    ["pointerup", "pointercancel", "touchend", "touchcancel", "mouseup", "mouseleave", "blur"].forEach((ev) => {
      btn.addEventListener(ev, stop, { passive: true });
      window.addEventListener(ev, stop, { passive: true });
    });
  }

  ready(function () {
    const root = qs("#ring-sizer");
    if (!root) return;

    // --- Elements ---
    const cardOption = qs(".card_option", root);
    const rulerOption = qs(".ruler_option", root);

    const measureMain = qs(".measure_main", root);
    const ringMain = qs(".ring_main", root);
    const resultMain = qs(".result_main", root);

    const calW = qs(".cal_w", root);
    const measureTitle = qs("#measure_title", root);
    const ringTitle = qs("#ring_title", root);

    const guideCard = qs("#guide_card", root);
    const guideRuler = qs("#guide_ruler", root);

    const cardContainer = qs(".card_container", root);
    const rulerContainer = qs(".ruler_container", root);
    const cardInner = qs(".card_position_inner", root);

    const btnMinus = qs("#buttons_botton_inner_minus", root);
    const btnPlus = qs("#buttons_botton_inner_plus", root);
    const btnApply = qs(".button_apply", root);

    const ringMinus = qs("#ring_minus", root);
    const ringPlus = qs("#ring_plus", root);
    const ringApply = qs(".ring_apply", root);

    const btnBack = qs(".btn_back", root);
    const resultSize = qs(".result_size", root);

    // Create/ensure cal_d exists (your old HTML sometimes didn't have it)
    let calD = qs(".cal_d", root);
    if (!calD) {
      calD = document.createElement("div");
      calD.className = "cal_d";
      calD.textContent = "Display korrekt!";
      const main = qs(".main", root);
      if (main && calW) main.insertBefore(calD, calW.nextSibling);
      calD.style.display = "none";
    }

    // --- State ---
    let setint = null;
    let width = 350;
    let tool = "card";
    let res = 40;
    let radiusRing = 45;

    // realistic default px/mm for ruler mode
    let gap = 6.5;

    // --- Ruler canvas (DPR-correct) ---
    const canvasRuler = qs("#ruler_canvas", root);
    const ctxRuler = canvasRuler ? canvasRuler.getContext("2d") : null;

    function resizeRulerCanvas() {
      if (!canvasRuler || !ctxRuler) return;

      // CSS size (how big it appears)
      const cssWidth = Math.min(700, window.innerWidth * 0.8);
      const cssHeight = 60;

      // Make it visible / stable under Shopify theme CSS
      canvasRuler.style.display = "block";
      canvasRuler.style.width = cssWidth + "px";
      canvasRuler.style.height = cssHeight + "px";

      // Actual backing store in device pixels
      const dpr = window.devicePixelRatio || 1;
      canvasRuler.width = Math.round(cssWidth * dpr);
      canvasRuler.height = Math.round(cssHeight * dpr);

      // Set transform so drawing uses CSS pixels
      ctxRuler.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function changeCardWidth(dir) {
      if (dir === "minus") width = width > 50 ? width - 1 : 50;
      else width = width < 1000 ? width + 1 : 1000;

      if (cardInner) cardInner.style.width = width + "px";
    }

    function drawRuler(type) {
      if (!ctxRuler || !canvasRuler) return;

      // If canvas was hidden before, ensure correct sizing now
      resizeRulerCanvas();

      if (type === "minus") {
        gap = gap > 3 ? parseFloat((gap - 0.01).toFixed(2)) : 3;
        // keep card width in sync (matches your original behavior)
        changeCardWidth("minus");
      } else if (type === "plus") {
        gap = gap < 20 ? parseFloat((gap + 0.01).toFixed(2)) : 20;
        changeCardWidth("plus");
      }

      // Clear in CSS pixels (because we setTransform)
      const cssW = canvasRuler.width / (window.devicePixelRatio || 1);
      const cssH = canvasRuler.height / (window.devicePixelRatio || 1);
      ctxRuler.clearRect(0, 0, cssW, cssH);

      ctxRuler.font = "10px sans serif";
      ctxRuler.fillStyle = "#707070";
      ctxRuler.strokeStyle = "#778a9d";
      ctxRuler.lineWidth = 1.2; // slightly thicker for retina + Shopify themes

      ctxRuler.beginPath();

      // Draw ticks across visible width in CSS pixels
      for (let x = 0; x <= cssW; x += gap) {
        const tickIndex = Math.round(x / gap);
        const lastDigit = parseInt(String(tickIndex).split("").reverse()[0], 10);

        let yOffset = lastDigit % 10 === 0 ? 0 : 10;
        if (yOffset === 10) yOffset = lastDigit % 5 === 0 ? 5 : 10;
        else ctxRuler.fillText(String(Math.round(x / (10 * gap))), x, 10 + yOffset);

        ctxRuler.moveTo(x + 2.5, 15.5 + yOffset);
        ctxRuler.lineTo(x + 2.5, 40.5);
      }

      ctxRuler.stroke();
    }

    // --- Ring canvas ---
    const canvasRing = qs("#ring_canvas", root);
    const ctxRing = canvasRing ? canvasRing.getContext("2d") : null;

    function drawRing(dir) {
      if (!ctxRing || !canvasRing) return;

      if (dir === "minus") radiusRing = radiusRing > 25 ? radiusRing - 0.5 : 25;
      else if (dir === "plus") radiusRing = radiusRing < 80 ? radiusRing + 0.5 : 80;

      ctxRing.clearRect(0, 0, canvasRing.width, canvasRing.height);

      // red inner ring
      ctxRing.lineWidth = 7;
      ctxRing.strokeStyle = "#ab2524";
      ctxRing.beginPath();
      ctxRing.arc(150, 150, radiusRing, 0, 2 * Math.PI);
      ctxRing.stroke();

      // golden outer ring with shadow
      ctxRing.lineWidth = 13;
      ctxRing.strokeStyle = "#dabd3c";
      ctxRing.shadowColor = "#e8b527";
      ctxRing.shadowOffsetX = 0;
      ctxRing.shadowBlur = 3;
      ctxRing.beginPath();
      ctxRing.arc(150, 150, radiusRing + 7, 0, 2 * Math.PI);
      ctxRing.stroke();

      // reset shadow
      ctxRing.shadowBlur = 0;
    }

function setActiveTool(nextTool) {
  tool = nextTool;

  if (tool === "card") {
    // WICHTIG: explizit block
    if (cardContainer) cardContainer.style.display = "block";
    if (rulerContainer) rulerContainer.style.display = "none";

    if (guideCard) guideCard.style.display = "inline";
    if (guideRuler) guideRuler.style.display = "none";

    if (rulerOption) {
      rulerOption.style.backgroundColor = "transparent";
      rulerOption.style.color = "#656565";
    }
    if (cardOption) {
      cardOption.style.backgroundColor = "#424d57";
      cardOption.style.color = "#fff";
    }

    gap = width / 85.6;

    // optional: damit Lineal (falls sichtbar) sauber ist
    drawRuler();
  } else {
    // WICHTIG: explizit block
    if (cardContainer) cardContainer.style.display = "none";
    if (rulerContainer) rulerContainer.style.display = "block";

    if (guideRuler) guideRuler.style.display = "inline";
    if (guideCard) guideCard.style.display = "none";

    if (cardOption) {
      cardOption.style.backgroundColor = "transparent";
      cardOption.style.color = "#656565";
    }
    if (rulerOption) {
      rulerOption.style.backgroundColor = "#424d57";
      rulerOption.style.color = "#fff";
    }

    gap = 6.5;

    // CRITICAL: container war vorher hidden -> resize+redraw
    drawRuler();
  }
}


function gotoRingStep() {
  if (measureMain) measureMain.style.display = "none";
  if (ringMain) ringMain.style.display = "block";

  if (calW) calW.style.display = "none";
  if (calD) calD.style.display = "block";

  if (measureTitle) measureTitle.style.display = "none";
  if (ringTitle) ringTitle.style.display = "block"; // WICHTIG!
}

function gotoMeasureStep() {
  if (measureMain) measureMain.style.display = "block";
  if (ringMain) ringMain.style.display = "none";

  if (calW) calW.style.display = "block";
  if (calD) calD.style.display = "none";

  if (measureTitle) measureTitle.style.display = "block";
  if (ringTitle) ringTitle.style.display = "none"; // WICHTIG!
}


   function gotoResult() {
  // Alles ausblenden
  if (measureMain) measureMain.style.display = "none";
  if (ringMain) ringMain.style.display = "none";

  if (calW) calW.style.display = "none";
  if (calD) calD.style.display = "none";

  if (measureTitle) measureTitle.style.display = "none";
  if (ringTitle) ringTitle.style.display = "none";

  // Ergebnis einblenden (WICHTIG: block, nicht "")
  if (resultMain) resultMain.style.display = "block";
  if (btnBack) btnBack.style.display = "flex";

  // Ringgrößenberechnung
  let result;
  if (tool === "card") {
    result = Number.parseFloat(
      ((2 * radiusRing) / (width / 85.6) - 12.7) / 0.3 + 39 - 6
    ).toFixed(0);
  } else {
    result = Number.parseFloat(
      ((2 * radiusRing) / gap - 12.7) / 0.3 + 39
    ).toFixed(0);
  }

  if (resultSize) resultSize.textContent = String(result);
}

function resetFromResult() {
  // Zurück zur Messung
  if (resultMain) resultMain.style.display = "none";
  if (btnBack) btnBack.style.display = "none";

  if (measureMain) measureMain.style.display = "block";
  if (ringMain) ringMain.style.display = "none";

  if (calW) calW.style.display = "block";
  if (calD) calD.style.display = "none";

  if (measureTitle) measureTitle.style.display = "block";
  if (ringTitle) ringTitle.style.display = "none";
}


    // --- Init visibility ---
    if (ringTitle) ringTitle.style.display = "none";
    if (calD) calD.style.display = "none";
    if (btnBack) btnBack.style.display = "none";
    if (resultMain) resultMain.style.display = "none";
    if (guideRuler) guideRuler.style.display = "none";

    // Init card width
    if (cardInner) cardInner.style.width = width + "px";

    // Init canvases
    resizeRulerCanvas();
    drawRuler();  // initial
    drawRing();   // initial

    // Default tool
    setActiveTool("card");

    // --- Bind interactions ---
    bindTap(cardOption, function () { setActiveTool("card"); });
    bindTap(rulerOption, function () { setActiveTool("ruler"); });

    bindTap(btnApply, gotoRingStep);
    bindTap(calD, gotoMeasureStep);

    bindTap(ringApply, gotoResult);
    bindTap(btnBack, resetFromResult);

    // Press & hold +/- for ruler
    pressAndHold(btnMinus, function () { drawRuler("minus"); });
    pressAndHold(btnPlus, function () { drawRuler("plus"); });

    // Press & hold +/- for ring
    pressAndHold(ringMinus, function () { drawRing("minus"); });
    pressAndHold(ringPlus, function () { drawRing("plus"); });

    // Redraw on resize
    window.addEventListener("resize", function () {
      resizeRulerCanvas();
      drawRuler();
    });
  });
})();
